import React from 'react';
import MetricResult, { MetricResultType } from '../types/metrics/metricResult';

export namespace Dashboard {
  export function getCacheKey(type: string, filter: any): string {
    return `${type}-${JSON.stringify(filter)}`;
  }
}

export interface DashboardContextProps {
  cache: Map<string, { data: MetricResult[]; type: MetricResultType }>;
  setCache: (items: Map<string, { data: MetricResult[]; type: MetricResultType }>) => void;
  cacheLoading: boolean;
}

const defaultContext: DashboardContextProps = {
  cache: new Map(),
  setCache: () => {},
  cacheLoading: false,
};

export const DashboardContext = React.createContext<DashboardContextProps>(defaultContext);
